import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useAnimation, AnimationControls } from "framer-motion";

type InViewRef = (node?: Element | null) => void;

export const AnimateInView = (): [InViewRef, AnimationControls] => {
  const controls = useAnimation();
  const [element, inView] = useInView({
    // Start shortly before the section reaches the viewport so its content is
    // already moving into place as the user scrolls to it.
    rootMargin: "0px 0px 140px 0px",
    threshold: 0.05,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("show");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView]);

  return [element, controls];
};
